import {
  ActivityLogTable,
  ContentLayout,
  CustomeDialog,
  Loader,
  LoadingButton,
  TabPanel,
  usePermission,
} from "../../../shared";
import * as React from "react";
import {
  Stack,
  Typography,
  Button,
  TextField,
  Box,
  Tab,
  Grid,
  Card,
  Link as ButtonLink,
  Tabs,
} from "@mui/material";
import { CustomTable } from "../../../shared";
import { sortItems } from "../../../utils";
import SimpleReactValidator from "simple-react-validator";
import InputControl from "../../../shared/components/InputControl";
import { Link } from "react-router-dom";
import { useMenuLog } from "../hooks";
import { AddMenuLogStoreIdDialog } from "./AddMenuLogStoreIdDialog";
import CloseIcon from "@mui/icons-material/Close";
import { TabContextProvider } from "../../../store";

export const MenulogList = () => {
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const {
    state,
    handleAllMenu,
    handlePushMenu,
    onChange,
    isEditable,
    isErrorModal,
    currentTab,
    setCurentTab,
    optionsMenuTemplate,
    handleInputChange,
    handleSubmit,
    handleModal,
    handleStoreActive,
    handleStoreStatus,
    handleOnChangeFilter,
  } = useMenuLog({
    isList: true,
  });

  const { selectedStore } = state;
  const canViewActivityLog = usePermission("activity-logs");

  const handleChange = (event, newValue) => {
    setCurentTab("menulog", newValue);
  };
  const onSubmit = () => {
    if (validator.current.allValid()) {
      handleSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  const ActionButtons = ({ value, id }) => {

    return (
      <div className="action-buttons">
        {value.lastest_message && !['SUCCESS', 'success', 'OK', '{"success":true}\n'].includes(value.lastest_message) && (
          <>
            <Stack gap="6px">
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500,
                  color: "#C42B1C",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => isErrorModal(true, value.lastest_message)}
              >
                Show Error
              </Typography>

              <Typography variant="caption" color="#808080">
                Last update was on {value?.last_update_at} failed.
              </Typography>
            </Stack>
          </>
        )}
        {value?.connection_status === 1 && value.status === 1 ? (
          <>
            {state.isSaveButton && state?.store_id === id ? (
              <>
                <Stack
                  direction="row"
                  alignItems="center"
                  gap="4px"
                  className="uber-loader"
                >
                  <Loader />
                  <Typography
                    variant="subtitle2"
                    fontWeight={500}
                    color="#C07302"
                  >
                    Uploading...
                  </Typography>
                </Stack>
              </>
            ) : (
              <div
                onClick={() =>
                  handlePushMenu(value?.store_id)
                }
              >
                <Stack>
                  <Stack
                    direction="row"
                    className="hover-icon-link"
                    gap={1}
                    sx={{ width: "fit-content" }}
                    alignSelf="end"
                  >
                    <img src="/icons/icon_blue_refresh.svg" />
                    <ButtonLink underline="none" component="button" variant="body2">
                      <Typography fontWeight={600}>Push Menu</Typography>
                    </ButtonLink>
                  </Stack>
                  {value.last_update_at ? (
                    <Typography variant="caption" color="#808080">
                      Last update was on {value?.last_update_at}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Stack>
              </div>
            )}
          </>
        ) : (
          ""
        )}
        {isEditable && (
          <>
            <InputControl
              id={id}
              type="toggle-switch"
              value={value.status}
              disabled={!value.connection_status}
              onChange={() => {
                handleModal("store-open", true, value)
              }}
            />
          </>
        )}
        <Link to={`details/${id}`}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Store",
        accessor: "store_name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
        Cell: ({ value, row }) => {
          return (
            <Stack direction="row" gap={2}>
              <Typography> {value}</Typography>
            </Stack>
          );
        },
      },
      {
        Header: "Set Up",
        accessor: "name",
        Cell: ({ row }) => {
          let value = row.original

          return (
            <Stack
              sx={{
                flexDirection: "row",
                gap: "8px",
                alignItems: "center"
              }}>
              {value?.connection_status === 1 ? (
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  onClick={() => handleModal("connect", true, row.original)}
                >
                  Disconnect
                </Button>
              ) : (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleModal("connect-id", true, row.original)}
                >
                  Connect
                </Button>
              )}
              {value.connection_status && value.external_store_id ?
                (<Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 400,
                    bgcolor: "#0000000F",
                    p: "4px 7px",
                    borderRadius: "8px"
                  }}
                >
                  {value.external_store_id}
                </Typography>
                )
                : ""
              }
            </Stack>
          );
        },
        disableSortBy: true,
      },
      {
        Header: "Action",
        id: "id",
        accessor: "id",
        align: "right",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return (
            <ActionButtons value={row.original} id={row.original.store_id} />
          );
        },
      },
    ],
    [state.isSaveButton, selectedStore, state.data.menulog_store_id]
  );

  const statusOptions = [
    { label: "Connected", value: 1 },
    { label: "Disconnected", value: 0 },
  ];

  return (
    <>
      <ContentLayout
        title="Menu Log"
        rightContent={
          <>
            {currentTab === "1" ? (
              <LoadingButton
                type="button"
                size="medium"
                variant="contained"
                onClick={handleAllMenu}
                disabled={state?.isSaveButton}
                loading={state?.isAllSaveButton}
                startIcon={<img src="/icons/icon_refresh.svg" />}
              >
                Push Menu
              </LoadingButton>
            ) : (
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={onSubmit}
                disabled={state.isSaveButtonBusy}
              >
                Save
              </Button>
            )}
          </>
        }
      >
        <Box
          className="sticky-Tab"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            top: "88px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs value={currentTab} onChange={handleChange}>
            <Tab label="Stores" value="1" />
            {/* <Tab label="Settings" value="2" /> */}
            {/* {canViewActivityLog && <Tab label="Activity Log" value="3" />} */}
          </Tabs>
        </Box>
        <TabContextProvider value={currentTab}>
          <TabPanel sx={{ px: "0" }} value="1">
            <CustomTable
              columns={columns}
              data={state?.filteredMenuLogList || state?.menuLogList}
              pagination={false}
              isLoading={state?.isBusy}
              tableId="menulog"
              filterContent={
                <>
                  <InputControl
                    type="select"
                    placeholder="Connection Status"
                    width="250px"
                    label="Connection Status"
                    optionValue={statusOptions}
                    value={state.connection_status}
                    onChange={(e, newValue) => handleOnChangeFilter(e)}
                  />
                  <Button
                    type="button"
                    size="medium"
                    variant="text"
                    color="gray"
                    sx={{
                      minWidth: "40px",
                      p: "8px",
                    }}
                    onClick={() => handleOnChangeFilter(null)}
                  >
                    <CloseIcon />
                  </Button>
                </>
              }
            />
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="2">
            <Card sx={{ p: "32px 24px", mb: "24px" }}>
              {validator.current.purgeFields()}
              {state.isBusy ? (
                <Loader />
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "150px" }}
                    >
                      Menu Template
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack width={"50%"} gap="20px">
                      <InputControl
                        type="dropdown"
                        disableClearable
                        options={optionsMenuTemplate ?? []}
                        getOptionLabel={(option) => option.label}
                        value={
                          (optionsMenuTemplate?.length > 0 &&
                            state.dataMenu.menu_id &&
                            optionsMenuTemplate?.find(
                              (c) => c.value === state.dataMenu.menu_id,
                            )) ||
                          null
                        }
                        onChange={(e, newValue) => {
                          handleInputChange({
                            target: {
                              name: "menu_id",
                              value: newValue.value,
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Menu Template"
                            required
                            error={validator.current.message(
                              "Menu Template",
                              state.dataMenu.menu_id,
                              "required",
                            )}
                            helperText={validator.current.message(
                              "Menu Template",
                              state.dataMenu.menu_id,
                              "required",
                            )}
                          />
                        )}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </Card>
          </TabPanel>
          {canViewActivityLog && (
            <TabPanel sx={{ px: "0" }} value="3">
              <ActivityLogTable id={null} subjectType="menulog" />
            </TabPanel>
          )}
        </TabContextProvider>
      </ContentLayout>
      <CustomeDialog
        open={state.isErrorOpen}
        handleClose={() => isErrorModal(false, null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: "423px", height: "155px", p: "24px 24px 16px" },
        }}
        isHeader={false}
        content={
          <Stack gap="12px" height="100%" justifyContent="space-between">
            <Typography variant="subtitle2">
              {state.errorMessages === '{"success":true}\n'
                ? "In progress"
                : state.errorMessages}
            </Typography>
            <Button
              variant="contained"
              sx={{
                width: "fit-content",
                alignSelf: "end",
              }}
              onClick={() => isErrorModal(false, null)}
            >
              Ok
            </Button>
          </Stack>
        }
      />
      <CustomeDialog
        open={state?.isOpen}
        handleClose={() => handleModal("connect-id", false, null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: "423px", height: "235px", p: "16px" },
        }}
        title={selectedStore?.store_name || "Store"}
        content={
          <AddMenuLogStoreIdDialog
            onChange={onChange}
            state={state}
            handleUpdate={() =>
              handleStoreActive(
                selectedStore,
                selectedStore?.connection_status ? false : true,
              )
            }
          />
        }
      />

      <CustomeDialog
        open={state.isOpenConnect}
        PaperProps={{
          sx: { width: "423px", height: "155px", p: "16px" },
        }}
        title="Alert"
        content={
          <Stack
            mt="8px"
            gap="10px"
            height="100%"
            justifyContent="space-between"
          >
            <Typography variant="subtitle2">
              {state.isModalType === "connect"
                ? `Do you want to ${selectedStore?.connection_status ? "Disconnect" : "Connect"} Menulog for ${selectedStore?.store_name} store?`
                : `Do you wish to ${!!selectedStore?.status ? "close" : "open"} Menulog services for ${selectedStore?.store_name}${!!selectedStore?.status ? " indefinitely" : ""}?`}
            </Typography>
            <Stack direction="col" justifyContent="end" gap={2}>
              <Button
                // disabled={isButtonLoading}
                variant="text"
                onClick={() => handleModal("connect", false, null)}
              >
                No
              </Button>
              <LoadingButton
                // loading={isButtonLoading}
                variant="contained"
                onClick={() => {
                  if (state.isModalType === "connect") {
                    handleStoreActive(
                      selectedStore,
                      selectedStore?.connection_status ? false : true,
                    );
                  } else {
                    handleStoreStatus(
                      selectedStore,
                      selectedStore?.status ? false : true,
                    );
                  }
                }}
              >
                Yes
              </LoadingButton>
            </Stack>
          </Stack>
        }
      />
    </>
  );
};
